module.exports = __webpack_public_path__ + "img/logo-hen.7d3d09db.png";